<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="linkKontrol"> Link kontrol
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import seoService from '../../../WSProvider/SeoService';
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataExon = "";
    export default {
        name: "SeoDetay",
        methods: {
            linkKontrol() {
                seoService.linkKontrol("test");
            }
        }
    }
</script>

<style scoped>

</style>